import { getReleases } from "@services/organization-service";
import { useEffect, useState } from "react";

const Copyright = () => {
	const [version, setVersion] = useState<string>();

	const getLatestVersionNumber = async () => {
		try {
			const releases = await getReleases();
			setVersion(releases.docs[0].data().version);
		} catch {
			// silently fail
		}
	};

	useEffect(() => {
		getLatestVersionNumber();
	}, []);

	const year = new Date().getFullYear();

	return (
		<div className="footer-content">
			<a href="https://facilityai.com" className="footer-link">
				© {year} FacilityAI, LLC
			</a>
			<span className="footer-divider">·</span>
			<span className="footer-text">All Rights Reserved</span>
			{version && (
				<>
					<span className="footer-divider">·</span>
					<span className="footer-text">v{version}</span>
				</>
			)}
			<span className="footer-divider">·</span>
			<a href="/releases" className="footer-link">
				Release Notes
			</a>
		</div>
	);
};

export { Copyright };
